/**
 * ChangeTime()
 * takes in a time in 24 hour format
 * then changes it to 12 hour format
 * @param time = time in 24 hour format
 */
function ChangeTime(time) {
    //split the time by ":"
    var timeArray = time.split(':');
        //if time hour is greater than 12 then time is just hour - 12 (pm)
        if(timeArray[0] > 12) {
            timeArray[0] = timeArray[0] - 12;
            return timeArray[0]+":"+timeArray[1]+"pm";
        // if time = 12 then time is 12 (pm)
        } else if (timeArray[0] === "12") {
            return timeArray[0]+":"+timeArray[1]+"pm"
        // if time is 00, then time is 12 (am)
        } else {
            if(timeArray[0] === "00") {
            timeArray[0] = 12;
            return timeArray[0]+':'+timeArray[1]+'am';
        //other wise for am, time in 12 hour format is the same as 24 hour format
            } else if(timeArray[0] >= 10 && timeArray[0] <= 11) {
                return timeArray[0]+':'+timeArray[1]+'am';
            } else {
                var delZero = timeArray[0].split("");
                return delZero[1]+":"+timeArray[1]+'am';
            }
        }
}
export default ChangeTime;